'<template>
   <div class="page_index_container" v-loading="loading">
      <!--banner图-->
      <div class="index_banner" v-if="banner.length > 0">
         <div>
            <el-carousel :autoplay="true" :interval="5000">
               <el-carousel-item v-for="(item, index) in banner" :key="index">
                  <a target="_blank" :href="item.adLink" v-if="item.adLink != null">
                     <div class="banner_items" :style="'background-image:url(' + item.adContent + ')'"></div>
                  </a>
                  <div class="banner_items" v-else :style="'background-image:url(' + item.adContent + ')'"></div>
               </el-carousel-item>
            </el-carousel>
         </div>
      </div>

      <!--首页主体-->
      <div class="index_container">
         <!--内部审计-->
         <section class="index_shenji">
            <div class="max_width">
               <div class="sj_title">
                  <b>内部审计</b>
                  <p>行业服务平台 <img src="../../assets/images/2023/icon_xia.png" alt=""></p>
               </div>
               <div class="sj_right_list">
                  <div class="l_item" v-for="item in shenji">
                     <router-link :to="item.link" v-if="item.type == 1">
                        <span class="iconfont" v-html="item.icon"></span>
                        <p>{{ item.name }}</p>
                     </router-link>
                     <a :href="item.link" target="_blank" v-else-if="item.type == 2">
                        <span class="iconfont" v-html="item.icon"></span>
                        <p>{{ item.name }}</p>
                     </a>
                     <a v-else-if="item.type == 3" @click="item.handler">
                        <span class="iconfont" v-html="item.icon"></span>
                        <p>{{ item.name }}</p>
                     </a>
                  </div>
               </div>
            </div>
         </section>

         <!--横向广告推荐位-->
         <section class="index_tiaozhuan">
            <div class="max_width">
               <div class="tz_item" v-for="item in topBanner">
                  <router-link :to="item.adLink" v-if="item.type == 1">
                     <img :src="item.adContent" :alt="item.caption">
                  </router-link>
                  <a :href="item.adLink" :title="item.caption" v-else-if="item.type == 2">
                     <img :src="item.adContent" :alt="item.caption">
                  </a>
                  <a :title="item.caption" v-else-if="item.type == 3" @click="item.handler">
                     <img :src="item.adContent" :alt="item.caption">
                  </a>
               </div>
            </div>
         </section>

         <!--党建引领，内审要闻-->
         <section class="index_dj_ns">
            <div class="max_width">
               <div class="l_djyl" v-if="artbox[0].load">
                  <div class="dj_ns_title">
                     <h5>{{ artbox[0].title }}</h5>
                     <router-link class="r_link" :to="artbox[0].more">查看更多+</router-link>
                  </div>
                  <div class="l_carousel">
                     <el-carousel height="286" :autoplay="true" :interval="5000">
                        <el-carousel-item v-for="(item, index) in artbox[0].list" :key="index">
                              <router-link  v-if="item.isOutLink=='N'" :to="'/list/' + artbox[0].parCode + '/info/' + item.code" target="_blank">
                                 <div class="banner_items" :style="'background-image:url(' + item.photo + ')'"
                                    :title="item.title"></div>
                              </router-link>
                           <a :href="item.outLinkUrl" v-if="item.isOutLink=='Y'" target="_blank">
                                <div class="banner_items" :style="'background-image:url(' + item.photo + ')'"
                                    :title="item.title"></div>
                           </a>

                        </el-carousel-item>
                     </el-carousel>
                  </div>
               </div>
               <div class="r_nsyw">
                  <div class="dj_ns_title">
                     <h5>{{ artbox[1].title }}</h5>
                     <router-link class="r_link" :to="artbox[1].more">查看更多+</router-link>
                  </div>
                  <div class="r_list">
                     <ul>
                        <li v-for="(item, index) in artbox[1].list">
                           <router-link :to="'/list/' + artbox[1].parCode + '/info/' + item.code" target="_blank">
                              <h5><span class="dian"></span>{{ item.title }}</h5>
                              <span class="date">{{ (item.createTime).slice(0, 10) }}</span>
                           </router-link>
                        </li>
                     </ul>
                  </div>
               </div>
            </div>
         </section>

         <!--动态信息 行业资讯-->
         <section class="index_newsbox">
            <div class="max_width">
               <div class="l_news">
                  <div class="news_item" v-for="(n, i) in artbox" v-if="i > 1 && i < 6">
                     <div class="news_title">
                        <h5>{{ n.title }}</h5>
                        <router-link class="r_link" :to="n.more">查看更多+</router-link>
                     </div>
                     <div class="new_list">
                        <ul>
                           <li v-for="(item, index) in n.list" :class="index == 0 ? 'active' : ''">
                              <router-link :to="'/list/' + n.parCode + '/info/' + item.code + '?rCode=' + n.code"
                                 target="_blank">
                                 <div class="imgbox">
                                    <img v-if="item.photo" :src="item.photo" :alt="item.title">
                                    <img v-else-if="n.title=='动态信息'" src="../../assets/images/dongtai.jpg"
                                       :alt="item.title">
                                    <img v-else-if="n.title=='行业资讯'" src="../../assets/images/hangye.jpg"
                                       :alt="item.title">
                                    <img v-else-if="n.title=='会员风采'" src="../../assets/images/fengcai.jpg"
                                       :alt="item.title">
                                    <img v-else-if="n.title=='CIA园地'" src="../../assets/images/CIA.jpg"
                                       :alt="item.title">
                                 </div>
                                 <div class="new_info">
                                    <h5><span class="iconfont">&#xe610;</span>{{ item.title }}</h5>
                                    <p>{{ (item.createTime).slice(0, 10) }}</p>
                                 </div>
                              </router-link>
                           </li>
                        </ul>
                     </div>
                  </div>
               </div>
               <div class="r_list">
                  <div class="list_right" v-for="(n, i) in artbox" v-if="i > 5 && i < 8">
                     <div class="l_title">
                        <h5>{{ n.title }}</h5>
                        <router-link :to="n.more" class="r_link">更多<i class="iconfont">&#xe63d;</i></router-link>
                     </div>
                     <div class="l_box">
                        <ul>
                           <li v-for="(item, index) in n.list">
                              <router-link :to="'/list/' + n.parCode + '/info/' + item.code + '?rCode=' + n.code"
                                 target="_blank">
                                 <span class="iconfont">&#xe8ff;</span>
                                 <h5>{{ item.title }}</h5>
                              </router-link>
                           </li>
                        </ul>
                     </div>
                  </div>
                  <div class="list_right2" v-for="(n, i) in artbox" v-if="i > 7">
                     <div class="l_title">
                        <h5>{{ n.title }}</h5>
                        <router-link :to="n.more" class="r_link">更多<i class="iconfont">&#xe63d;</i></router-link>
                     </div>
                     <div class="l_box">
                        <ul>
                           <li v-for="(item, index) in n.list">
                              <router-link :to="'/list/' + n.parCode + '/info/' + item.code + '?rCode=' + n.code"
                                 target="_blank">
                                 <h5>{{ item.title }}</h5>
                              </router-link>
                           </li>
                        </ul>
                     </div>
                  </div>
               </div>
            </div>
         </section>


         <!--广告-->
         <section class="index_gg">
            <div class="max_width" v-if="bottomBanner.length > 0">
               <a :href="item.adLink" v-for="item in bottomBanner">
                  <img :src="item.adContent" alt="">
               </a>
            </div>
         </section>

         <section class="index_bottom_links">
            <div class="max_width">
               <div class="links_item" v-for="(item, indx) in link">
                  <a :href="item.linksUrl" target="_blank">
                     <img :src="item.linksPhoto" alt="">
                  </a>
               </div>
            </div>
         </section>
      </div>

   </div>
</template>


<script>
   import {
      formatDates,
      getDistanceSpecifiedTime
   } from '@/assets/js/date.js'; // 时间倒计时
   import {
      getCookie,
      delCookie,
      setCookie
   } from '@/assets/js/util'; // cookie操作
   export default {
      name: 'index2_page',
      components: {},

      data() {
         const validatePhone = (rule, value, callback) => {
            // console.log(rule)
            // console.log(value)
            // console.log(callback)

            // 判断输入框中是否输入手机号
            if (!value) {
               callback(new Error('手机号不能为空'))
            }
            //正则表达式进行验证手机号，从1开始，第二位是35789中的任意一位，以9数字结尾
            if (!/^1\d{10}$/.test(value)) {
               callback(new Error('手机号格式不正确'))
            }
            callback()
         }
         return {
            loading: false,
            banner: [{
                  adLink: null,
                  adContent: require('../../assets/images/2023/banner.jpg'),
               },
               {
                  adLink: null,
                  adContent: require('../../assets/images/2023/banner.jpg'),
               },
            ],
            topBanner: [{
               "adLink": '/live',
               "adContent": "/profile/upload/ZvIR32/2023/05/07/06f30919-80d8-4d6c-8b1b-26050a5ae1aa.jpg",
               "adInfo": null,
               "caption": "在线直播",
               type: 1,
            }, {
               "adLink": 'http://www.bjabia.org/listMsTrainInfo.do?type=web&groupId=2',
               "adContent": "/profile/upload/ZvIR32/2023/05/07/24a09cf7-e35a-40e2-a3d1-5ea445044ced.jpg",
               "adInfo": null,
               "caption": "面授培训",
               type: 2,
            }, {
               "adLink": '/member/list',
               "adContent": "/profile/upload/ZvIR32/2023/05/07/527535bf-f26c-49da-a9ab-4f03eff65251.jpg",
               "adInfo": null,
               "caption": "会员名录",
               "type": 1,
            }], //顶部横向广告推荐位
            shenji: [{
                  icon: '&#xe629;',
                  name: '会员登录',
                  link: '/login',
                  type: 1,
               },
               {
                  icon: '&#xe627;',
                  name: '入会申请',
                  link: '/member/join',
                  type: 1,
               },
               {
                  icon: '&#xe61d;',
                  name: '后续教育',
                  link: 'http://www.bjabia.org/',
                  type: 2,
               },
               {
                  icon: '&#xec4c;',
                  name: 'CIA查询',
                  link: 'http://learning.viewteam.cn/getExamCertificate.do?flag=web',
                  type: 2,
               },
               {
                  icon: '&#xe64b;',
                  name: '专题申报',
                  link: '/zhuanti/join',
                  type: 1,
               },
               {
                  icon: '&#xe636;',
                  name: '杂志订阅',
                  link: '',
                  type: 3,
                  "handler": this.getzazhiList
               },
            ],
            djyl: require('@/assets/images/2023/djyl_img.jpg'),

            artbox: [{
                  title: '党建引领',
                  more: '/list/7ZR3Ib',
                  code: '7ZR3Ib',
                  parCode: '7ZR3Ib',
                  list: [],
                  load: false,
                  pagesize: 5,
               },
               {
                  title: '内审要闻',
                  more: '/list/news?rCode=yqqMny',
                  code: 'yqqMny',
                  parCode: 'news',
                  list: [],
                  load: false,
                  pagesize: 9,
               },
               {
                  title: '动态信息',
                  more: '/list/news?rCode=bMfyIr',
                  code: 'bMfyIr',
                  parCode: 'news',
                  list: [],
                  load: false,
                  pagesize: 7,
               },
               {
                  title: '行业资讯',
                  more: '/list/news?rCode=AVZNry',
                  code: 'AVZNry',
                  parCode: 'news',
                  list: [],
                  load: false,
                  pagesize: 7,
               },
               {
                  title: '会员风采',
                  more: '/list/news?rCode=vaEfI3',
                  code: 'vaEfI3',
                  parCode: 'news',
                  list: [],
                  load: false,
                  pagesize: 7,
               },
               {
                  title: 'CIA园地',
                  more: '/list/news?rCode=uqqYNr',
                  code: 'uqqYNr',
                  parCode: 'news',
                  list: [],
                  load: false,
                  pagesize: 7,
               },
               {
                  title: '通知通告',
                  more: '/list/news?rCode=qQZNNf',
                  code: 'qQZNNf',
                  parCode: 'news',
                  list: [],
                  load: false,
                  pagesize: 5,
               },
               {
                  title: '标准规范',
                  more: '/list/vaAFjq?rCode=RfeQn2',
                  code: 'RfeQn2',
                  parCode: 'vaAFjq',
                  list: [],
                  load: false,
                  pagesize: 5,
               },

               {
                  title: '法律法规',
                  more: '/list/vaAFjq?rCode=eQnAri',
                  code: 'eQnAri',
                  parCode: 'vaAFjq',
                  list: [],
                  load: false,
                  pagesize: 5,
               },
            ],

            link: [],

            bottomBanner: [], //底部banner
            userInfo: {}, //登陆信息
            loginStatus: false,

         };
      },
      mounted() {
         this.initPage();
         if (this.$getCookie('sd_token')) {
            this.loginStatus = true;
            this.getUserInfo();
            this.shenji[0].name = '会员单位';
            this.shenji[0].link = '/user/member';
         }
      },
      methods: {
         initPage() {
            var _this = this;
            this.getBanner('3UNnui', 1);
            this.getBanner('aARjUz', 2);
            _this.artbox.forEach((e, i) => {
               _this.getartList(i);
            });
            this.getlist();
         },
         getBanner(code, type) {
            var _this = this;
            _this.$api.fgList({
               guanggaoCode: code,
            }).then(res => {
               if (res.code == 200) {
                  if (type == 1) {
                     _this.banner = res.data;
                  }
                  if (type == 2) {
                     _this.bottomBanner = res.data;
                  }
               } else {
                  _this.$message.error(res.msg);
               }
            }).catch(function (error) {
               _this.$message.error(error.msg);
            });
         },
         getartList(index) {
            var _this = this;
            _this.$api.artList({
               categoryCode: _this.artbox[index].code,
               pageSize: _this.artbox[index].pagesize
            }).then(res => {
               if (res.code == 200) {
                  _this.artbox[index].list = res.data.list;
                  _this.artbox[index].load = true;
                  for (var i = 0; i < _this.artbox[index].list.length; i++) {

                  }
                  // console.log(_this.artbox,'3333333')
               } else {
                  _this.$message.error(res.msg);
               }
            }).catch(function (error) {
               _this.$message.error(error.msg);
            });
         },
         getUserInfo() {
            var _this = this;
            _this.$api.companyInfo({
               token: _this.$getCookie('sd_token')
            }).then(res => {
               if (res.code == 200) {
                  _this.userInfo = res.data;
                  localStorage.setItem('userInfo', JSON.stringify(res.data));
                  _this.loginStatus = true;
               } else {
                  _this.$message.error(res.msg);
               }
            }).catch(function (error) {
               _this.loading = false;
               _this.$message.error(error.msg);
            });
         },
         getlist() {
            var _this = this;
            _this.$api.linksList().then(res => {
               _this.loading = false;
               if (res.code == 200) {
                  _this.link = res.data;
               } else {
                  _this.$message.error(res.msg);
               }
            }).catch(function (error) {
               _this.$message.error(error.msg);
            });
         },
         getzazhiList() {
            var _this = this;
            _this.$api.zazhiList({
               pageNum: 1,
               pageSize: 1
            }).then(res => {
               _this.loading = false;
               if (res.code == 200) {
                  _this.$router.push('/zazhi/dingyue/' + res.data.list[0].code)
               } else {
                  _this.$message.error(res.msg);
               }
            }).catch(function (error) {
               _this.loading = false;
               _this.$message.error(error.msg);
            });
         },
      }
   }
</script>
<style lang="less"></style>